import { render, staticRenderFns } from "./uploadDegree.vue?vue&type=template&id=5f097938&scoped=true&"
import script from "./uploadDegree.vue?vue&type=script&lang=js&"
export * from "./uploadDegree.vue?vue&type=script&lang=js&"
import style0 from "./uploadDegree.vue?vue&type=style&index=0&id=5f097938&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f097938",
  null
  
)

export default component.exports